import { render, staticRenderFns } from "./plural.vue?vue&type=template&id=316da0af&scoped=true"
import script from "./plural.vue?vue&type=script&lang=js"
export * from "./plural.vue?vue&type=script&lang=js"
import style0 from "./plural.vue?vue&type=style&index=0&id=316da0af&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316da0af",
  null
  
)

export default component.exports